"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutBucketCorsOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=PutBucketCorsOutput.js.map